<template>
  <div class="d-flex flex-column">
    <span
      v-if="!hideLabel"
      class="caption font-size-12 mb-2 grey--text text--darken-2"
    >
      {{ fieldLabel }}
    </span>

    <AssigneesSelection
      class="mb-2"
      v-if="selectedAccounts && selectedAccounts.length"
      :maxItemsToShow="15"
      :accounts="selectedAccounts"
      :disabled="disabled"
      :loading="initialLoading && Boolean(selectedAccountIds.length)"
      @remove="handleRemoveItem"
    />
    <AssigneesSearchPopover
      :availableLocalAccounts="availableLocalAccounts"
      :localSearch="localSearch"
      :showAdvancedOption="showAdvancedOption"
      :includeTeams="includeTeams"
      :disabled="disabled"
      :maxSelectableAccounts="maxSelectableAccounts"
      :multiple="multiple"
      :selectedAccountIds="selectedAccountIds"
      :blacklist="blacklist"
      :filters="filters"
      :zIndex="zIndex"
      @change="handleChangeAssignees"
      @initialLoad="$event => (selectedAccounts = $event)"
      @loading="initialLoading = $event"
    >
      <v-btn
        rounded
        small
        class="blue-grey--text text--darken-1 body-2 mr-2 selector-button-trigger"
        color="blue-grey lighten-3"
        elevation="0"
        data-tourid="assignee-selector-trigger"
        :disabled="disabled"
      >
        <v-icon size="16" class="mr-1" color="blue-grey darken-1">
          mdi-plus
        </v-icon>
        <p class="ma-0">
          {{ buttonCopy }}
        </p>
      </v-btn>
    </AssigneesSearchPopover>

    <v-text-field
      v-if="rules.length || (validationRules && validationRules.length)"
      v-model="selectedAccountIds"
      class="field-to-validate-assignees-selected"
      :rules="validationRules || rules"
    />
  </div>
</template>

<script>
import AssigneesSelection from './AssigneesSelection.vue'
import AssigneesSearchPopover from '@/components/AssigneesSearchPopover/AssigneesSearchPopover.vue'

export default {
  name: 'AssigneesSelector',

  components: {
    AssigneesSelection,
    AssigneesSearchPopover,
  },

  props: {
    availableLocalAccounts: {
      type: Array,
      default: () => [],
    },
    localSearch: Boolean,
    disabled: Boolean,
    maxSelectableAccounts: {
      type: Number,
      default: null,
    },
    multiple: Boolean,
    required: Boolean,
    selectedAccountIds: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
    },
    buttonText: {
      type: String,
    },
    includeTeams: Boolean,
    showAdvancedOption: Boolean,
    blacklist: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
    validationRules: {
      type: Array,
      required: false,
    },
    hideLabel: Boolean,
    zIndex: Number,
  },

  data() {
    return {
      error: false,
      selectedAccounts: [],
      initialLoading: false,
    }
  },

  watch: {
    selectedAccountIds: {
      immediate: true,
      handler() {
        if (this.availableLocalAccounts.length)
          this.setSelectedAccountsFromLocal()
      },
    },

    availableLocalAccounts: {
      immediate: true,
      handler() {
        this.setSelectedAccountsFromLocal()
      },
    },
  },

  computed: {
    rules() {
      const rules = []
      if (this.required)
        rules.push(
          items =>
            items.length > 0 || this.$t('assignee_selector.min_assignees_error')
        )
      if (this.maxSelectableAccounts)
        rules.push(
          items =>
            items.length <= this.maxSelectableAccounts ||
            this.$t('assignee_selector.maximum_assignees', {
              maxAssignees: this.maxSelectableAccounts,
            })
        )
      return rules
    },

    fieldLabel() {
      const label = this.label ?? `${this.$t('common.assignee_other')}`
      const requiredMark = this.required ? '*' : ''
      return `${label}${requiredMark}`
    },

    buttonCopy() {
      return this.buttonText ?? this.$t('common.assign_users')
    },
  },

  methods: {
    handleRemoveItem(item) {
      this.selectedAccounts = this.selectedAccounts.filter(
        selectedAccount => selectedAccount._id !== item._id
      )
      const newSelectedAccountIds = this.selectedAccounts.map(
        selectedAccount => selectedAccount._id
      )
      this.$emit('change', newSelectedAccountIds)
    },

    handleChangeAssignees(event) {
      this.selectedAccounts = event.items
      this.$emit('change', event.ids)
    },

    setSelectedAccountsFromLocal() {
      this.selectedAccounts = this.availableLocalAccounts.filter(account =>
        this.selectedAccountIds.includes(account.id)
      )
    },
  },
}
</script>

<style>
.v-input.field-to-validate-assignees-selected .v-input__control .v-input__slot {
  display: none !important;
}
</style>
